import { httpClient } from "../http/httpClient";


export const fetchTotalStatesReservations = async (): Promise<any> => {
  return httpClient.get('transfer-reservations/total-states-colors');
};
